<template>
  <card-component v-if="isAdvisor && isInactive" title="Account not active">
    <p>Your account is not activated yet. You will be notified by email, when administrator activate your account.</p>
  </card-component>

  <missed-chats :chats="missedChats" @message-client="forceOpenMessageModal" />

  <div v-if="isAdvisor" class="row">
    <div class="col-xl-8 col-lg-12" :class="{ 'is-loading': shortPaymentStatsLoading || loadingTransactions }">
      <card-component
        class="overflow-y-scroll"
        style="min-height: 381px"
        :title="!shortPaymentStats ? 'Earnings' : 'Lifetime earnings - $' + Number(shortPaymentStats.total_earned).toFixed(2)"
      >
        <div class="chart-wrapper">
          <canvas id="transactions_chart_home-chart" />
        </div>
      </card-component>
    </div>
    <div class="col-xl-4 col-lg-12" :class="{ 'is-loading': loadRecentClients }">
      <card-component title="Recent clients" :wide="true">
        <div id="recent-clients" class="media-list position-relative">
          <div v-for="client in recentClients" :key="client.name" class="media border-0">
            <div class="media-left pr-1">
              <span class="avatar avatar-md avatar-online">
                <avatar class="media-object" :username="client.name" :src="client.avatar" :size="40" />
              </span>
            </div>
            <div class="media-body w-100">
              <h6 class="list-group-item-heading">
                {{ client.name }}
              </h6>
              <p class="list-group-item-text mb-0">
                <button class="btn btn-warning btn-sm" @click="forceOpenMessageModal(client)">
                  <font-awesome-icon icon="envelope" />
                  Message
                </button>
              </p>
            </div>
          </div>
          <div v-if="!recentClients.length" class="text-center text-muted">No recent clients yet...</div>
        </div>
      </card-component>
    </div>
  </div>

  <div v-if="isAdvisor" class="row" :class="{ 'is-loading': shortPaymentStatsLoading }">
    <div class="col-xl-8 col-lg-12">
      <card-component title="Recent payments" style="height: 339px">
        <div v-if="shortPaymentStats" class="table-responsive fixTableHead">
          <table class="table table-hover table-auto overflow-scroll mb-0">
            <thead>
              <tr>
                <th>Amount</th>
                <th>Type</th>
                <th>Client</th>
                <th>Source</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="transaction in shortPaymentStats.last_transactions" :key="transaction.id">
                <td class="text-truncate">
                  <span v-if="transaction.change_type === 'outcome'">-</span>${{
                    isUser ? Number(transaction.total_amount).toFixed(2) : Number(transaction.user_amount).toFixed(2)
                  }}
                </td>
                <td class="text-truncate">
                  <span>
                    <span v-if="transaction.type === 'charge'">inbox</span>
                    <span v-else-if="transaction.type === 'chat' && transaction.details">
                      <span v-if="transaction.details.mode == 'text'">Text Chat</span>
                      <span v-else-if="transaction.details.mode == 'audio'">Voice Call</span>
                      <span v-else-if="transaction.details.mode == 'video'">Video Call</span>
                    </span>
                    <span v-else-if="transaction.type === 'subscription'">Subscription</span>
                    <span v-else>{{ transaction.type }}</span>
                  </span>
                </td>
                <td class="text-truncate">
                  <span v-if="getUserInfo(transaction)">
                    <avatar
                      :username="getUserInfo(transaction).name"
                      :src="getUserInfo(transaction).avatar"
                      :size="20"
                      style="display: inline-block"
                    />
                    {{ getUserInfo(transaction).name }}
                    <a v-if="getUserInfo(transaction).role_name === 'user'" href="javascript:;" @click="openMessageModal(getUserInfo(transaction))"
                      ><i class="ion-email"
                    /></a>
                    <se-link v-if="isUser" :href="{ path: '/advisor/:url', params: { url: getUserInfo(transaction).url } }">
                      <font-awesome-icon icon="info-circle" />
                    </se-link>
                  </span>
                </td>
                <td class="text-truncate">
                  <span v-if="transaction.type === 'chat' || transaction.type === 'charge'">
                    <se-button
                      v-if="transaction.type === 'chat'"
                      size="xsmall"
                      type="primary"
                      @click="$router.push({ path: '/dashboard/history/:id', params: { id: transaction.chat_id } })"
                    >
                      Chat
                    </se-button>
                    <se-button
                      v-else
                      size="xsmall"
                      type="secondary"
                      @click="$router.push({ path: '/dashboard/inbox', query: { id: transaction.inbox_id } })"
                    >
                      Inbox
                    </se-button>
                    <!--                      <SeLink class="btn btn-sm btn-primary"-->
                    <!--                            :href="{ path: '/dashboard/history/:id', params: { id: transaction.chat_id } }"-->
                    <!--                            v-if="transaction.type === 'chat'">-->
                    <!--                      -->
                    <!--                      </se-link>-->
                    <!--                      <SeLink class="btn btn-sm btn-info"-->
                    <!--                            :href="{ path: '/dashboard/inbox', query: { id: transaction.inbox_id } }"-->
                    <!--                            v-else>-->
                    <!--                      Inbox-->
                    <!--                      </se-link>-->
                  </span>
                  <span v-else>{{ transaction.type === 'refill' ? 'Paypal' : transaction.type }}</span>
                </td>
                <td class="text-truncate">
                  {{ transaction.created_at }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="!shortPaymentStats || !shortPaymentStats.last_transactions" class="text-center text-muted">No payments yet...</div>
      </card-component>
    </div>

    <div class="col-xl-4 col-lg-12" :class="{ 'is-loading': !currentUser || !currentUser.id }">
      <div class="card" style="height: 339px">
        <div class="text-center">
          <div class="card-body">
            <avatar v-if="currentUser && currentUser.id" :username="currentUser.name" :src="currentUser.avatar" :size="120" style="margin: auto" />
            <avatar v-else username="Advisor" :size="120" style="margin: auto" />
          </div>
          <div class="card-body mt-0">
            <h4 class="card-title">
              {{ currentUser.name }}
            </h4>
            <h6 class="card-subtitle text-muted">Total monthly sales: ${{ shortPaymentStats ? shortPaymentStats.last_month_earnings : 0 }}</h6>
          </div>
          <div class="text-center mb-2">
            <se-button type="primary" @click="$router.push('/dashboard/profile/edit')"> Edit profile </se-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <card-component v-if="isAdvisor && isActive" title="Promote your profile!">
    <div class="field">
      <label class="label"
        >Public profile url:
        <a
          href="javascript:;"
          class="tooltip-question"
          data-tooltip="Your profile url. With feedback, accuracy and other useful information."
          data-tooltip-length="large"
          data-tooltip-pos="up"
          >?</a
        >
      </label>
      <p class="control">
        <input
          class="form-control"
          type="text"
          :value="'https://' + host + '/advisor/' + currentUser.url"
          @focus="$event.target.select()"
          @mouseup.prevent=""
        />
      </p>
    </div>
    <div class="field">
      <label class="label">
        Chat url:
        <a href="javascript:;" class="tooltip-question" data-tooltip="Direct url for chat with you." data-tooltip-length="large" data-tooltip-pos="up"
          >?</a
        >
      </label>
      <p class="control">
        <input
          class="form-control"
          type="text"
          :value="'https://' + host + '/chat/' + currentUser.url"
          @focus="$event.target.select()"
          @mouseup.prevent=""
        />
      </p>
    </div>
    <div class="field">
      <label class="label">
        Free chat url:
        <a
          href="javascript:;"
          class="tooltip-question"
          data-tooltip="Almost the same as chat url, but if client start chat from this page for the firs time (first time uses free chat) it will start free chat. You can ask client to hire you with your per minute fee."
          data-tooltip-length="large"
          data-tooltip-pos="up"
          >?</a
        >
      </label>
      <p class="control">
        <input
          class="form-control"
          type="text"
          :value="'https://' + host + '/chat/' + currentUser.url + '/free'"
          @focus="$event.target.select()"
          @mouseup.prevent=""
        />
      </p>
    </div>
  </card-component>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { mapActions, mapState } from 'pinia';
import Chart from 'chart.js/auto';
import MissedChats from '@/src/components/MissedChats';
import CardComponent from '@/src/components/CardComponent';
import SeLink from '@/src/components/Link';
import Avatar from '@/src/components/Avatar';
import { reportsStore } from '@/src/store/reports';
import { usersStore } from '@/src/store/users';
import { chatStore } from '@/src/store/chat';
import { inboxStore } from '@/src/store/inbox';
import { TimeCalculations } from '@/src/helpers/timeCalculations';
import _ from '@/src/helpers/arrayHelpers';
import SeButton from '@/src/ui-kit/button/Button';
import { useStorage } from '@/src/composables/useStorage';

const { getStorageValue, setStorageValue } = useStorage();

export default {
  name: 'SeAdvisorDashboard',
  meta() {
    return {
      title: 'Dashboard',
    };
  },
  components: {
    SeButton,
    MissedChats,
    CardComponent,
    Avatar,
    SeLink,
    // AdvisorProfilePopUp,
    FontAwesomeIcon,
  },
  data() {
    return {
      onlineAdvisors: [],
      myAdvisors: [],
      notMyAdvisors: [],
      missedChats: [],
      loadingAdvisors: false,
      groupBy: 'day',
      host: !import.meta.env.SSR ? window.location.host : '',
      tour: null,
      hasTour: false,
      dateRange: '',
      week: [new Date(new Date().valueOf() - 3600 * 1000 * 24 * 7), new Date()],
      month: '',
      year: '',
      recentChats: [],
      loadRecentChats: false,
      recentAdvisors: [],
      loadRecentAdvisors: false,
      recentClients: [],
      loadRecentClients: false,
      onlineTopAdvisors: [],
      loadTopAdvisors: false,
      shortStats: null,
      shortStatsLoading: false,
      shortPaymentStats: null,
      shortPaymentStatsLoading: false,
      // perfect scrollbar
      ps: null,
      // chart
      transactionsChart: null,
      transactionsRange: ['', ''],
    };
  },
  mounted() {
    this.hasTour = getStorageValue('_tour');

    // Making prefetched values being available before page shell.
    this.updateCurrentUserFromPrefetched();

    if (this.isAdmin || this.isSupport) {
      // When sign in this page is opened for all users, opening correct one for admin.
      this.$router.push('/admin-dashboard/users');
    }

    // set date ranges for advisor balance chart
    this.dateRange = this.week;
    this.month = [new Date(new Date().valueOf() - 3600 * 1000 * 24 * 30), new Date()];
    this.year = [new Date(new Date().setFullYear(new Date().getFullYear() - 1)), new Date()];

    // get home page data out of role
    if (this.isUser) {
      this.getMyAdvisors();
      this.getNotMyAdvisors();
      // this.getRecentChats();
      // this.getRecentAdvisors();
      // this.getOnlineTopAdvisors();
      // this.getOnlineAdvisors();
    } else if (this.isAdvisor) {
      this.getChatPenalties();
      this.getRecentClients();
      this.getShortStats();
      this.getShortPaymentStats();
      this.getChartTransactions().then(() => {
        this.transactionsRange = [new Date(new Date().setFullYear(new Date().getFullYear() - 1)), new Date()];
        setTimeout(() => {
          this.drawTransactionsChart();
        }, 0);
      });
    }
  },
  methods: {
    ...mapActions(reportsStore, ['getChartTransactions']),
    ...mapActions(usersStore, ['setOnlineUsers']),
    ...mapActions(chatStore, ['saveParam']),
    ...mapActions(inboxStore, ['openMessageModal', 'forceOpenMessageModal']),
    getUserInfo(transaction) {
      if (transaction?.details && transaction?.type) {
        if (transaction.type === 'chat') {
          return this.isUser ? transaction.details.advisor : transaction.details.client;
        }
        if (transaction.type === 'charge') {
          return this.currentUser.id === transaction.details.user_1_id ? transaction.details.user_2 : transaction.details.user_1;
        }
        if (transaction.type === 'subscription') {
          return this.isUser ? transaction.details.advisor : transaction.details.client;
        }
      }
      return null;
    },
    drawTransactionsChart() {
      if (this.transactionsChart !== null) {
        this.transactionsChart.destroy();
      }
      const ctx = document.getElementById('transactions_chart_home-chart');
      if (ctx) {
        this.transactionsChart = new Chart(ctx.getContext('2d'), {
          type: 'line',
          data: {
            labels: this.transactionsChartData.labels,
            datasets: [
              {
                label: 'Wallet changes',
                data: this.transactionsChartData.data,
                backgroundColor: 'rgba(34, 194, 220, 0.5)',
                borderColor: 'rgba(34, 194, 220, 0.5)',
                // borderWidth: 0
              },
            ],
          },
          options: {
            scales: {
              y: {
                ticks: {
                  beginAtZero: true,
                },
              },
              x: {
                // type: 'time',
                time: {
                  displayFormats: {
                    millisecond: 'MMM dd',
                    second: 'MMM dd',
                    minute: 'MMM dd',
                    hour: 'MMM dd',
                    day: 'MMM dd',
                    week: 'MMM dd',
                    month: 'MMM dd',
                    quarter: 'MMM dd',
                    year: 'MMM dd',
                  },
                  minUnit: this.groupBy !== 'month' ? 'day' : 'month',
                  unit: this.groupBy !== 'month' ? 'day' : 'month',
                },
              },
            },
            responsive: true,
            maintainAspectRatio: false,
          },
        });
      }
    },
    getShortPaymentStats() {
      this.shortPaymentStatsLoading = true;

      this.$api
        .get('/api/user/short-stats/payment')
        .then((res) => {
          this.shortPaymentStats = res.data;
          this.shortPaymentStatsLoading = false;
        })
        .catch((error) => {
          console.error(error.response);
          this.shortPaymentStatsLoading = false;
        });
    },
    getShortStats() {
      this.shortStatsLoading = true;
      this.$api
        .get('/api/user/short-stats')
        .then((res) => {
          this.shortStats = res.data;
          this.shortStatsLoading = false;
        })
        .catch((error) => {
          console.error(error.response);
          this.shortStatsLoading = false;
        });
    },
    renderDate(date) {
      return TimeCalculations.formatDate(date);
    },
    getOnlineTopAdvisors() {
      this.loadTopAdvisors = true;
      this.$api
        .get('/api/user/online-top')
        .then((res) => {
          this.onlineTopAdvisors = res.data;
          this.loadTopAdvisors = false;
        })
        .catch((err) => (this.loadTopAdvisors = false));
    },
    getRecentChats() {
      this.loadRecentChats = true;
      this.$api
        .get('/api/chat/recent')
        .then((res) => {
          this.recentChats = res.data;
          this.loadRecentChats = false;
        })
        .catch(() => (this.loadRecentChats = false));
    },
    getRecentAdvisors() {
      this.loadRecentAdvisors = true;
      this.$api
        .get('/api/chat/recent-advisors')
        .then((res) => {
          this.recentAdvisors = [
            ...res.data.filter((item) => item.status === 'online'),
            ...res.data.filter((item) => item.status === 'busy'),
            ...res.data.filter((item) => item.status === 'offline'),
          ];
          this.loadRecentAdvisors = false;
        })
        .catch(() => (this.loadRecentAdvisors = false));
    },
    getRecentClients() {
      this.loadRecentClients = true;
      this.$api
        .get('/api/chat/recent-clients')
        .then((res) => {
          this.recentClients = res.data;
          this.loadRecentClients = false;
        })
        .catch(() => (this.loadRecentClients = false));
    },
    // get my online advisors
    getMyAdvisors() {
      // this.loadingAdvisors = true;
      this.$api
        .get('/api/user/my-advisors?for_slider=1')
        // this.$api.get('/api/user/advisors/my-online-advisors')
        .then((res) => {
          this.myAdvisors = res.data;
          // this.loadingAdvisors = false;
        })
        .catch((err) => {
          console.error(err, err.response);
          // this.loadingAdvisors = false;
        });
    },
    getNotMyAdvisors() {
      // this.loadingAdvisors = true;
      this.$api
        .get('/api/user/not-my-advisors?for_slider=1')
        // this.$api.get('/api/user/advisors/my-online-advisors')
        .then((res) => {
          this.notMyAdvisors = res.data;
          // this.loadingAdvisors = false;
        })
        .catch((err) => {
          console.error(err, err.response);
          // this.loadingAdvisors = false;
        });
    },
    setDateRange(range) {
      this.dateRange = range;
    },
    // initiate tour
    startTour() {
      const _this = this;
      const tour = new Shepherd.Tour({
        defaults: {
          classes: 'shepherd-theme-square-dark',
          showCancelLink: true,
        },
      });

      this.tour = tour;

      this.tour.on('cancel', () => {
        _this.destroyTour();
      });
      this.tour.on('complete', () => {
        _this.destroyTour();
      });

      tour.addStep('you', {
        title: 'It`s you.',
        text: 'By clicking on your avatar you will see dropdown menu where you can sign out from the app.',
        attachTo: '.user-shepherd-item bottom',
        advanceOn: '.docs-link click',
        buttons: [
          {
            text: 'Next',
            action: tour.next,
            classes: 'shepherd-button-example-primary',
          },
        ],
      });

      tour.addStep('notif', {
        title: 'Notifications.',
        text: 'All notifications will be stored here. By clicking the bell you will see dropdown with last notifications.',
        attachTo: '.notifications-shepherd-item bottom',
        advanceOn: '.docs-link click',
        buttons: [
          {
            text: 'Skip',
            classes: 'shepherd-button-secondary',
            action: tour.cancel,
          },
          {
            text: 'Next',
            action: tour.next,
            classes: 'shepherd-button-example-primary',
          },
        ],
      });

      if (this.isAdvisor && this.isActive) {
        tour.addStep('status', {
          title: 'Presence status.',
          text: 'You can change your status to online/offline (while you are not in chat).',
          attachTo: '#panel .status-change-item right',
          advanceOn: '.docs-link click',
          when: {
            cancel() {
              _this.destroyTour();
            },
          },
          buttons: [
            {
              text: 'Skip',
              classes: 'shepherd-button-secondary',
              action: tour.cancel,
            },
            {
              text: 'Next',
              action: tour.next,
              classes: 'shepherd-button-example-primary',
            },
          ],
        });
      }

      tour.addStep('dashboard-home', {
        title: 'Dashboard home.',
        text: 'By cliking this menu item you always returns to this page (dashboard home).',
        attachTo: '#panel .dashboard-home right',
        advanceOn: '.docs-link click',
        buttons: [
          {
            text: 'Skip',
            classes: 'shepherd-button-secondary',
            action: tour.cancel,
          },
          {
            text: 'Next',
            action: tour.next,
            classes: 'shepherd-button-example-primary',
          },
        ],
      });

      let walletText = 'This is your in-app wallet. You can add funds and see your payment history.';
      if (this.isAdvisor) walletText = 'This is your in-app wallet. You can see your payment history and withdraw yours earnings.';

      tour.addStep('payment-menu-item', {
        title: 'Payments.',
        text: walletText,
        attachTo: '#panel .payment-menu-item right',
        advanceOn: '.docs-link click',
        buttons: [
          {
            text: 'Skip',
            classes: 'shepherd-button-secondary',
            action: tour.cancel,
          },
          {
            text: 'Next',
            action: tour.next,
            classes: 'shepherd-button-example-primary',
          },
        ],
      });

      tour.addStep('active-chat', {
        title: 'Active chat.',
        text: 'Your active chat will always appear here. You can access it just by clicking this menu item.',
        attachTo: '#panel .active-chat right',
        advanceOn: '.docs-link click',
        buttons: [
          {
            text: 'Skip',
            classes: 'shepherd-button-secondary',
            action: tour.cancel,
          },
          {
            text: 'Next',
            action: tour.next,
            classes: 'shepherd-button-example-primary',
          },
        ],
      });

      tour.addStep('chat-history', {
        title: 'Chats history.',
        text: _this.isUser
          ? 'Every chat history is stored here. You can download or delete history of any chat if you want!'
          : 'Every chat history is stored here.',
        attachTo: '#panel .chat-history right',
        advanceOn: '.docs-link click',
        buttons: [
          {
            text: 'Skip',
            classes: 'shepherd-button-secondary',
            action: tour.cancel,
          },
          {
            text: 'Next',
            action: tour.next,
            classes: 'shepherd-button-example-primary',
          },
        ],
      });

      tour.addStep('inbox', {
        title: 'Inbox messaging.',
        text: _this.isUser
          ? 'Your free messages with advisor are always here.'
          : 'Your free messages here. But you can request one time payment from client for messaging sessions if you need.',
        attachTo: '#panel .user-inbox right',
        advanceOn: '.docs-link click',
        buttons: [
          {
            text: 'Skip',
            classes: 'shepherd-button-secondary',
            action: tour.cancel,
          },
          {
            text: 'Next',
            action: tour.next,
            classes: 'shepherd-button-example-primary',
          },
        ],
      });

      tour.addStep('payment-menu-item', {
        title: 'Unsubscribe from email.',
        text: 'Here you can unsubscribe email notifications from our app.',
        attachTo: '#panel .unsubscribe-item right',
        advanceOn: '.docs-link click',
        buttons: [
          {
            text: 'Skip',
            classes: 'shepherd-button-secondary',
            action: tour.cancel,
          },
          {
            text: 'Next',
            action: tour.next,
            classes: 'shepherd-button-example-primary',
          },
        ],
      });

      if (this.isUser) {
        tour.addStep('edit-profile', {
          title: 'Edit your profile.',
          text: 'Here you can change your name and upload your profile picture.',
          attachTo: '#panel .edit-my-data right',
          advanceOn: '.docs-link click',
          buttons: [
            {
              text: 'Skip',
              classes: 'shepherd-button-secondary',
              action: tour.cancel,
            },
            {
              text: 'Next',
              action: tour.next,
              classes: 'shepherd-button-example-primary',
            },
          ],
        });

        tour.addStep('payment-menu-item', {
          title: 'Your advisors.',
          text: 'Here is all advisors that you have contacted.',
          attachTo: '#panel .my-advisors right',
          advanceOn: '.docs-link click',
          buttons: [
            {
              text: 'Finish',
              classes: 'shepherd-button-example-primary',
              action: tour.complete,
            },
          ],
        });
      }

      if (this.isAdvisor) {
        tour.addStep('payment-menu-item', {
          title: 'Your profile.',
          text: 'Your profile preview is here. Also you can change your information and upload profile picture here.',
          attachTo: '#panel .my-profile right',
          advanceOn: '.docs-link click',
          when: {
            cancel() {
              _this.destroyTour();
            },
          },
          buttons: [
            {
              text: 'Skip',
              classes: 'shepherd-button-secondary',
              action: tour.cancel,
            },
            {
              text: 'Next',
              action: tour.next,
              classes: 'shepherd-button-example-primary',
            },
          ],
        });
        tour.addStep('payment-menu-item', {
          title: 'Your clients.',
          text: 'Here is all clients that you have contacted.',
          attachTo: '#panel .my-clients right',
          advanceOn: '.docs-link click',
          when: {
            cancel() {
              _this.destroyTour();
            },
          },
          buttons: [
            {
              text: 'Skip',
              classes: 'shepherd-button-secondary',
              action: tour.cancel,
            },
            {
              text: 'Next',
              action: tour.next,
              classes: 'shepherd-button-example-primary',
            },
          ],
        });
        tour.addStep('payment-menu-item', {
          title: 'Data reports.',
          text: 'Here is reports from your activity (with charts).',
          attachTo: '#panel .data-reports right',
          advanceOn: '.docs-link click',
          buttons: [
            {
              text: 'Finish',
              classes: 'shepherd-button-example-primary',
              action: tour.complete,
            },
          ],
        });
      }

      tour.start();
    },
    // destroy tour
    destroyTour() {
      _.each(this.tour.steps, (step) => {
        step.destroy();
      });
      this.tour = null;
      setStorageValue('_tour', 1);
      this.hasTour = 1;
    },
    getChatPenalties() {
      // get missed chats
      this.$api
        .get('/api/user/missed-chats')
        .then((res) => (this.missedChats = res.data))
        .catch((error) => console.error(error.response));
    },
  },
  computed: {
    ...mapState(usersStore, [
      'updateCurrentUserFromPrefetched',
      'currentUser',
      'isAuthenticated',
      'isAdmin',
      'isSupport',
      'isAdvisor',
      'isUser',
      'isActive',
      'isInactive',
      'onlineUsers',
    ]),
    ...mapState(reportsStore, ['chartTransactions', 'loadingTransactions']),
    myOnlineAdvisors() {
      return _.filter(this.myAdvisors, (item) => item.status !== 'offline');
    },
    filteredOnlineAdvisors() {
      if (!this.onlineAdvisors) return [];
      const ids = _.map(this.myAdvisors, (item) => item.id);
      return _.filter(this.onlineAdvisors, (item) => ids.indexOf(item.id) === -1);
    },
    groupTransactionForRange() {
      const diff = TimeCalculations.getDaysFromDate(this.transactionsRange[0], this.transactionsRange[1]);

      this.groupBy = 'day';
      if (diff >= 32 && diff < 150) {
        this.groupBy = 'week';
      } else if (diff >= 150) {
        this.groupBy = 'month';
      }
      let format = 'll';

      if (this.groupBy === 'month') format = 'MMM yyyy';

      return _.chain(this.chartTransactions)
        .groupBy((item) => TimeCalculations.rawFormatBeginningOf(item.created_at, this.groupBy, format))
        .map((group, label) => ({
          label,
          data: group[0],
        }))
        .sortBy((item) => TimeCalculations.rawDateObject(item.label, format))
        .value();
    },
    rangeTransactions() {
      let current = TimeCalculations.rawDateObject(this.transactionsRange[0]);
      const diff = TimeCalculations.getDaysFromDate(this.transactionsRange[0], this.transactionsRange[1]);

      this.groupBy = 'day';
      if (diff >= 32 && diff < 150) {
        this.groupBy = 'week';
      } else if (diff >= 150) {
        this.groupBy = 'month';
      }
      let format = 'll';
      let adding = 'days';

      if (this.groupBy === 'month') adding = 'month';

      if (this.groupBy === 'month') format = 'MMM yyyy';
      else if (this.groupBy === 'week') adding = 'week';

      const filtered = _.filter(
        this.groupTransactionForRange,
        (item) =>
          item &&
          item.data &&
          TimeCalculations.getSecondsFromDate(item.data.created_at, this.transactionsRange[1]) >= 0 &&
          TimeCalculations.getSecondsFromDate(this.transactionsRange[0], item.data.created_at) >= 0
      );

      while (TimeCalculations.getSecondsFromDate(current, this.transactionsRange[1]) >= 0) {
        if (_.filter(filtered, (item) => item.label === TimeCalculations.rawFormat(current, format)).length === 0) {
          const filt = _.chain(this.groupTransactionForRange)
            .filter((item) => TimeCalculations.getSecondsFromDate(current, item.data?.created_at) < 0)
            .value();

          if (filt.length > 0) {
            filtered.push({ label: TimeCalculations.rawFormat(current, format), data: filt[filt.length - 1].data });
          } else {
            filtered.push({ label: TimeCalculations.rawFormat(current, format), data: { user_wallet_amount: 0 } });
          }
        }

        current = TimeCalculations.rawAddTime(current, 1, adding);
      }
      return _.sortBy(filtered, (item) => TimeCalculations.rawDateObject(item.label, format));
    },
    transactionsChartData() {
      return {
        data: _.map(this.rangeTransactions, (item) => item.data?.user_wallet_amount),
        labels: _.map(this.rangeTransactions, (item) => item.label),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/src/styles/variables';

canvas {
  height: 300px;
}

.text-muted {
  opacity: 0.7;
}

.card-content1 .media-list .media {
  width: 100%;
}

.card-content1 .media-list .media {
  padding-top: 0.75em;
  padding-bottom: 0.75em;
}

h3.content-header-title {
  font-size: 1.8rem !important;
  text-transform: none !important;
}

.fixTableHead {
  overflow-y: auto;
  height: 280px;
  border-top: 1px solid #e3ebf3;
}

.fixTableHead thead th {
  position: sticky;
  top: 0;
  background-color: white;
  border-bottom: 1px solid #e3ebf3;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  padding: 12px 15px;
  border: 1px solid #e3ebf3;
}
</style>
